import { Maybe } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

import { CapitalizePipe } from './capitalize.pipe';

import { PackageCategory } from '@iss/wo-common/trade-off';

@Pipe({ name: 'packageCategory', pure: false, standalone: true })
export class PackageCategoryPipe extends CapitalizePipe implements PipeTransform {
  public override transform(value: Maybe<PackageCategory>): string {
    switch (value) {
      case 'SHREDDING_OFFSITE':
        return 'Shredding by exchange';
      case 'SHREDDING_ONSITE':
        return 'Shredding on site by emptying';
      default:
        return super.transform(value);
    }
  }
}
